import { render, staticRenderFns } from "./L3.vue?vue&type=template&id=61996a12&scoped=true&"
import script from "./L3.vue?vue&type=script&lang=js&"
export * from "./L3.vue?vue&type=script&lang=js&"
import style0 from "./L3.vue?vue&type=style&index=0&id=61996a12&prod&lang=scss&scoped=true&"
import style1 from "./L3.vue?vue&type=style&index=1&id=61996a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61996a12",
  null
  
)

export default component.exports